// ** React Imports
import { useState } from "react";

// ** Redux & Store & Actions
import { useDispatch, useSelector } from "react-redux";
import { setSentSmsCodeTime } from "store/modules/auth";

// ** Third Party Components
import { toast } from "helpers/toastWrapper";
import { useTranslation } from "react-i18next";

// ** Utils & Helpers
import api from "helpers/ApiClient";

// #####################################################

export const useResendSmsCode = () => {
	const dispatch = useDispatch();
	const { t } = useTranslation(["common", "landing"]);

	const { login, id, hash } = useSelector(
		(state) => state.globalCommon.registrationVerifyPhoneModal
	);

	const [isSending, setIsSending] = useState(false);

	const resendSmsCode = ({ phoneNumber, countryCode, isoCountryCode }) => {
		const phoneWithoutSpaces = phoneNumber.replace(/\s/g, "");
		const phoneWithCodeAsString = `${countryCode}${phoneWithoutSpaces}`;
		const phoneWithCodeAsNumber = parseInt(phoneWithCodeAsString);

		setIsSending(true);

		api.put(`/authorization/registration/verify/phone`, {
			id: +id,
			hash,
			login,
			phone: phoneWithCodeAsNumber,
			country: isoCountryCode,
		})
			.then((res) => {
				dispatch(
					setSentSmsCodeTime({
						sentTime: res.data?.sms?.send,
						blockTime: res.data?.sms?.block,
					})
				);

				toast.success(
					t("landing:register.otp.step2.resendSuccessText")
				);
			})
			.catch((res) => {
				toast.error(res?.response?.data?.error);
			})
			.finally(() => {
				setIsSending(false);
			});
	};
	return {
		resendSmsCode,
		isSending,
	};
};
